import React, { FC } from 'react';
import IconButton from '@mui/material/IconButton';

import { DeleteIcon } from 'src/shared/components';

interface Props {
  onClick: () => void;
  disabled: boolean;
}

export const TimesheetDeleteCell: FC<Props> = ({ onClick, disabled }) => {
  return (
    <IconButton size="small" onClick={onClick} disabled={disabled}>
      <DeleteIcon size={20} />
    </IconButton>
  );
};
